import { RefObject } from 'react';
import { FC } from 'react';
import { NumberFormatProps } from './Input/plugins/useNumberFormat';
import { useNumberFormat } from './Input/plugins/useNumberFormat';
import { Props as UncontrolledTextInputProps } from './UncontrolledTextInput';
import { UncontrolledTextInput } from './UncontrolledTextInput';

export type ExtraProps = NumberFormatProps & {
    value: number | null;
    onChange: (value: number | null) => void;
    inputRef?: RefObject<HTMLInputElement>;
};

export type Props = ExtraProps &
    Omit<UncontrolledTextInputProps, keyof ExtraProps>;

export const NumberInput: FC<Props> = ({
    value: externalValue,
    onChange: externalOnChange,
    format,
    min,
    max,
    precision,
    fixedPrecision,
    ...props
}) => {
    const numberProps = useNumberFormat({
        format,
        min,
        max,
        precision,
        fixedPrecision,
        value: externalValue,
        onChange: externalOnChange,
    });

    return <UncontrolledTextInput {...props} {...numberProps} type="number" />;
};
